/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PdfViewerAliases {
  PANEL_0 = 'panel-0',
  PDF_VIEWER = 'pdf-viewer',
}
export { PdfViewerAliases };
